module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('search', {
    attrs: {
      "placeholder": "搜索",
      "results": _vm.results
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.msg))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1d3a75c2"}!./~/.1.0.61@vux-loader/src/template-loader.js!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/search.vue
// module id = 104
// module chunks = 1